import moment from 'moment';
import React from 'react';
import Chip from '../Chips';
import Button from '../Button';
import Icon from '../Icons/Icon';
import { P3, P3Bold } from '../Text';
import colours from '../Colours';
import { Trans } from 'react-i18next';
import { DS_BookingDateAndTime } from './VehicleBookingsRow';
import { Slider } from '@material-ui/core';
import MediaSlider from '../MediaSlider';

const VehicleMediaRow = (props) => {

    let {booking, alt} = props;

    const AddMedia = (booking) => {
        props.onAdd(booking);
    }

    const EditMedia = (id) => {
        props.history.push(props.match.url + '/media_modal/' + id + '/edit');
    }

    const DismissMedia = (booking) => {
        props.onDismiss(booking);
    }

    return (
        <tr key={"all_media_" + "type_" + booking.tab + "_" + booking.BOOK_ID} className="ds-booking-row" style={{backgroundColor: alt ? '#F4F6F8' : 'white'}}>
            <td className="align-center">
                <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                    <Chip type={booking.tab}/>
                </div>
            </td>
            <td className="align-left" style={{width: 200}}>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                    <Icon name={booking.Book_Type == 2 ? 
                        "Car" : booking.profile.Is_User == 1 ? "User" : "Tag"} size={24} />
                    <div style={{display: 'flex', flex: 1, flexDirection: 'column', minHeight: 72}}>
                        <div style={{marginLeft: 4, display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center'}}>
                            {booking.Book_Type == 2 ? 
                            <>
                                <P3Bold>Service</P3Bold>
                                <P3 style={{color: colours.primary.grey02}}>{booking.Vehicle_Usage}</P3>
                            </> 
                            : <>
                                <P3Bold>{booking.profile.First_Name ? booking.profile.First_Name : ""} {booking.profile.Last_Name ? booking.profile.Last_Name : ''}</P3Bold>
                                {booking.profile.Title && booking.profile.Company? 
                                    <P3 style={{color: colours.primary.grey02}}>{booking.profile.Title + " at " + booking.profile.Company}</P3>
                                    : null
                                }
                            </>
                        }
                        </div>
                    </div>
                </div>
            </td>
            <td className = "date-cell">
                <DS_BookingDateAndTime booking={booking}/>
            </td>
            <td>
                <P3Bold>{moment(booking.End_Date).fromNow()}</P3Bold>
            </td>
            <td>
                {booking.Date_Published ? 
                    <P3Bold>{moment(booking.Date_Published).format('MMM DD, YYYY')}</P3Bold>
                : null}
            </td>
            <td>
                { booking.Rating != null ?
                    <div className="mediarating-slider">
                        <MediaSlider value={booking.Rating} readOnly/>
                    </div>
                : null }
            </td>
            <td className = "action-cell">
                {booking.tab === 'outstanding' ?
                    <div style={{display: 'flex', flexDirection: 'row', flex: 2, justifyContent: 'center', alignItems: 'center'}}>
                        <Button small secondary leading_ic="MediaAdd" label="Add Media" style={{marginRight: 16}} onClick={()=>AddMedia(booking)}/>
                        <div style={{width: 54}}>
                            <Button small secondary color={colours.accent.error_red} label="Dismiss" onClick={()=>DismissMedia(booking)}/>
                        </div>
                    </div>
                : booking.tab === 'dismissed' ?
                    <div style={{display: 'flex', flex: 2, flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                        <Button small secondary leading_ic="MediaAdd" label="Add Media" style={{marginRight: 16}} onClick={()=>AddMedia(booking)}/>
                        <div style={{width: 54}}></div>
                    </div>
                : booking.tab === 'completed' ?
                    <div style={{display: 'flex', flex: 2, flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                        <Button small secondary leading_ic="Edit" label="Edit Media" style={{marginRight: 16}} onClick={()=>EditMedia(booking.ID)}/>
                        <div style={{width: 54}}></div>
                    </div>
                : null}
                {/* Buttons */}
            </td>
        </tr>
    )
}

export default VehicleMediaRow;